import { Link } from 'react-router-dom'

import { LOGIN_PATH } from '../lib/nav'
import LoginForm from './LoginForm'

export default function UserLogin() {
  return (
    <div className="login login--user">
      <section className="login-card">
        <img className="brand-logo brand-logo--lg" src="/simat-logo.png" alt="SIMAT Technologies" />
        <h1>เข้าสู่ระบบพนักงาน</h1>
        <p className="login-lead">ดูเวลาทำงาน ยื่นใบลา และขอ OT ของตัวเอง</p>

        <LoginForm kind="user" usernameLabel="รหัสพนักงาน" usernamePlaceholder="เช่น 10001" />

        <p className="login-alt">
          เป็นเจ้าหน้าที่ฝ่ายบุคคล? <Link to={LOGIN_PATH.admin}>เข้าสู่ระบบผู้ดูแล</Link>
        </p>

        <p className="meta">ลืมรหัสผ่าน ให้ติดต่อฝ่ายบุคคล — หน้านี้ตั้งรหัสใหม่เองไม่ได้</p>
      </section>
    </div>
  )
}
